import { Icon } from '@iconify/react';
import React from 'react';
import { Link } from 'react-router-dom';

export default function SocialWidget() {
  return (
    <div className="cs_social_links_wrap">
      <h2>Follow Us</h2>
      <div className="cs_social_links">
        <Link to="https://www.facebook.com/p/Freedom-Prosthetics-100023570654434/">
          <Icon icon="fa-brands:facebook-f" />
        </Link>
{/*         <Link to="https://www.facebook.com/p/Freedom-Prosthetics-100023570654434/">
          <Icon icon="fa-brands:youtube" />
        </Link> */}
        <Link to="https://www.linkedin.com/in/david-bryan-b1462090/">
          <Icon icon="fa-brands:linkedin-in" />
        </Link>
{/*         <Link to="/">
          <Icon icon="fa-brands:twitter" />
        </Link> */}
        <Link to="https://www.instagram.com/Freedom_Prosthetics_LA?fbclid=IwY2xjawLZCTVleHRuA2FlbQIxMABicmlkETFtOHgzQTJSMXE4S3hBTDRYAR62Te-KPqhpudou_US0g94on0_c1hZj33YS7_TsxUXfl68ZJSNlx_3tpr11tQ_aem_f9xAJKWX3-VrhPmUmZByjw">
          <Icon icon="fa-brands:instagram" />
        </Link>
      </div>
    </div>
  );
}
